import React from "react";

const BorderTheme = ({ theme = "default" }) => {
  return (
    <div
      className="border-wrapper"
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Main content area */}
      <div style={{ flex: 1, position: "relative" }}>
        {/* This is where the content will go */}
      </div>

      {/* Border overlays */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: "none",
        }}
      >
        {/* Top border tiles horizontally */}
        <div
          style={{
            backgroundImage: `url(/borders/${theme}/border-horizontal.png)`,
            backgroundRepeat: "repeat-x",
            backgroundSize: "auto 60px",
            height: "60px",
            width: "100%",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />
        {/* Left border tiles vertically */}
        <div
          style={{
            backgroundImage: `url(/borders/${theme}/border-left.png)`,
            width: "60px",
            height: "100%",
            backgroundRepeat: "repeat-y",
            backgroundSize: "60px auto",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />
        {/* Right border tiles vertically */}
        <div
          style={{
            backgroundImage: `url(/borders/${theme}/border-right.png)`,
            width: "60px",
            height: "100%",
            backgroundRepeat: "repeat-y",
            backgroundSize: "60px auto",
            position: "absolute",
            top: 0,
            right: 0,
          }}
        />
        {/* Bottom border tiles horizontally */}
        <div
          style={{
            backgroundImage: `url(/borders/${theme}/border-horizontal.png)`,
            backgroundRepeat: "repeat-x",
            backgroundSize: "auto 60px",
            height: "60px",
            width: "100%",
            position: "absolute",
            bottom: 0,
            left: 0,
          }}
        />
      </div>
    </div>
  );
};

export default BorderTheme;
